<template>
  <div >
    <h1>404 Error</h1>
    <p>
      404 Error
    </p>
  </div>
</template>

<script>
export default {
  name: 'notFound404',
  metaInfo: {
    meta: [
      { vmid: 'description', name: 'description', content: 'bar' }
    ]
  }
}
</script>
